/**
 * The type of redux action which stores a specific JSON Web Token (JWT) into
 * the redux store.
 *
 * {
 *     type: SET_USERDATA,
 *     jwt: string
 * }
 */
export const SET_TRANSCRIPTION_ENABLED = 'SET_TRANSCRIPTION_ENABLED';
export const SET_TRANSCRIPTION_FONTSIZE_VALUE = 'SET_TRANSCRIPTION_FONTSIZE_VALUE';
export const SET_TRANSCRIPTION_HISTORY_VALUE = 'SET_TRANSCRIPTION_HISTORY_VALUE';
export const UPDATE_TRANSCRIPT_LINK = 'UPDATE_TRANSCRIPT_LINK';
